import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { LocaleLanguage } from './locale-language';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-language',
  templateUrl: './language-selection.component.html',
  imports: [
    TranslateModule,
    FormsModule,
  ]
})
export class LanguageSelectionComponent implements OnInit {

  public langKey: string = '';
  public finish = new EventEmitter<LocaleLanguage | null>();

  public languages: LocaleLanguage[] = [];
  public currentLanguage?: LocaleLanguage;

  constructor(private bsModalRef: BsModalRef, private localeResourceManager: LocaleResourceManager) { }

  public ngOnInit(): void {
    this.languages = this.localeResourceManager.getLanguages();
    this.currentLanguage = !this.langKey ? this.localeResourceManager.currentLanguage : this.localeResourceManager.getLanguageByKey(this.langKey);
  }

  public close(): void {
    this.bsModalRef.hide();
    this.finish.emit(null);
  }

  public changeLanguage(): void {
    this.bsModalRef.hide();
    this.finish.emit(this.currentLanguage);
  }
}
